import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { Button, Icon, TextStyle, Link } from '@shopify/polaris';
import { CircleInformationMajor, ExternalMinor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';

import { allowToSubscribeBFCMCode } from 'src/helpers/subscription-helper';
import {
  allowToShowBFCM22,
  allowToShowBFCM23,
  allowToShowSpecialDiscount,
  BFCM23_CODE
} from 'src/helpers/dashboard-helper';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';
import { Xmas22Constants } from 'src/constants/campaigns';
import { Upvoty } from '@upvoty/react'
import { isByPassScript } from './integrations/shopify-app-bridge/app';

function withShopifyEmbeddedAppPushState(WrappedComponent) {
  class EmbeddedAppRoute extends React.Component {
    state = {
      actionSurvey: false
    };

    componentWillUpdate(nextProps) {
      console.log('Pushing new URL to AppBridge History:', this.props.computedMatch.url, nextProps.computedMatch.url);
      if (this.props.computedMatch.url !== nextProps.computedMatch.url && !isByPassScript() && window.shopify?.protocol) {
        // window.history.replaceState({}, '', nextProps.computedMatch.url);
        window.shopify.protocol.send('Navigation.history.replace', { path: nextProps.computedMatch.url })
      }
    }

    render() {
      const { showSurvey = true, tenantApp = {}, isOpenFullScreen, i18n } = this.props;
      const { installStatus } = tenantApp;

      const allowedBFCMCode = allowToSubscribeBFCMCode(tenantApp);
      const allowedBFCM2022Code = allowToShowBFCM22(tenantApp);
      const alowSpecialDiscount = allowToShowSpecialDiscount(
        tenantApp,
        Xmas22Constants.startDate,
        Xmas22Constants.endDate
      );

      const bfcm23 = allowToShowBFCM23(tenantApp);

      if (!isOpenFullScreen && bfcm23.allow && installStatus === '') {
        return this.renderBFCM23Footer(i18n, bfcm23);
      }

      return (
        <React.Fragment>
          <WrappedComponent {...this.props} />
          {/* Display footer for BFCM 2022 */}
          {!isOpenFullScreen &&
            allowedBFCM2022Code &&
            this.renderSpecialDiscountFooter(allowedBFCMCode, showSurvey)}

          {/* Display footer for BFCM 2022 */}
          {!isOpenFullScreen &&
            alowSpecialDiscount &&
            this.renderSpecialDiscountFooter(allowedBFCMCode, showSurvey)}

          {/* Display in-app survey */}
          {!isOpenFullScreen && !allowedBFCMCode && showSurvey && this.renderInAppSurvey()}
        </React.Fragment>
      );
    }

    renderInAppSurvey = () => {
      const { i18n } = this.props;

      const projectId = process.env.REACT_APP_UPVOTY_PROJECT_ID;

      return (
        <div className="BC-Bottom__Feedback">
          <div className="feedback">
            <span className="icon">
              <img src={getAssetURL(ADMIN_APP_ASSET_PATHS?.common?.ideaIc)} alt="img" />
            </span>
            <Upvoty projectId={projectId}></Upvoty>
            <span>
              {i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.spanText')}{' '}
              <a style={{ textDecoration: 'none', color: '#2C6ECB' }} href="#" data-upvoty>
                {i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.buttonChildren')}
              </a>
            </span>
          </div>
        </div>
      );
    };

    renderSpecialDiscountFooter = (allowedBFCMCode, showSurvey) => {
      const { i18n } = this.props;

      return (
        <div
          className="BC-Bottom__Feedback"
          style={
            !allowedBFCMCode && showSurvey ? { paddingBottom: '10px', marginBottom: '-4rem' } : {}
          }>
          <div className="feedback">
            <span className="icon">
              <Icon source={CircleInformationMajor} color="primary" />
            </span>
            <span>
              {i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Footer_content', {
                discount: (
                  <span style={{ fontWeight: 'bold' }}>
                    <TextStyle variation="negative">
                      {i18n.translate(
                        `AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Footer_Discount_Percent`
                      )}
                    </TextStyle>
                  </span>
                ),
                duration: (
                  <TextStyle variation="strong">
                    <i>
                      {i18n.translate(
                        `AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Footer_Duration`
                      )}
                    </i>
                  </TextStyle>
                )
              })}{' '}
              <Button
                plain
                onClick={() => {
                  history.push(
                    `${routes.subscription.discount()}?&itm_source=inapp&itm_medium=footer-link&itm_campaign=xmas22`
                  );
                }}>
                {i18n.translate(
                  'AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Footer_Explore_Now'
                )}
                <img
                  className="new-tab"
                  src={getAssetURL(ADMIN_APP_ASSET_PATHS?.campaigns?.newTabBlue)}
                  alt=""
                  width="10"
                  height="10"
                  style={{ marginLeft: '4px' }}
                />
              </Button>
            </span>
          </div>
        </div>
      );
    };

    renderBFCM23Footer = (i18n, bfcm23) => {
      return (
        <React.Fragment>
          <WrappedComponent {...this.props} />
          <div className="BC-Bottom__Feedback">
            <div className="feedback">
              <span className="icon">
                <Icon source={CircleInformationMajor} color="primary" />
              </span>
              {bfcm23.type === 'professional365' ? (
                <span>
                  {i18n.translate(
                    'AdminHTML.Dashboard.SubscriptionStatus.BFCM2023_Footer_text_analytic',
                    {
                      code: <b>{BFCM23_CODE.ANALYTIC365}</b>
                    }
                  )}
                  <span className="img-new-tab no-underline">
                    <Link
                      external
                      onClick={() => {
                        history.push(routes.subscription.plan());
                      }}
                    // url={routes.subscription.plan()}
                    >
                      {i18n.translate(
                        'AdminHTML.Dashboard.SubscriptionStatus.BFCM2023_Footer_text_analytic2'
                      )}
                      <Icon source={ExternalMinor} color="interactive" />
                    </Link>
                  </span>
                </span>
              ) : (
                <span>
                  {i18n.translate(
                    'AdminHTML.Dashboard.SubscriptionStatus.BFCM2023_Footer_text_bfcm',
                    {
                      code: <b>{BFCM23_CODE.PLAN}</b>
                    }
                  )}
                  <span className="img-new-tab no-underline">
                    <Link
                      external
                      onClick={() => {
                        history.push(routes.subscription.package());
                      }}
                    // url={routes.subscription.plan()}
                    >
                      {i18n.translate(
                        'AdminHTML.Dashboard.SubscriptionStatus.BFCM2023_Footer_text_bfcm2'
                      )}
                      <Icon source={ExternalMinor} color="interactive" />
                    </Link>
                  </span>
                </span>
              )}
            </div>
          </div>
        </React.Fragment>
      );
    };

    leaveFeedback = () => {
      const { actionSurvey } = this.state;

      this.setState({ actionSurvey: !actionSurvey });
    };
  }

  const mapDispatchToProps = () => ({});

  const mapStateToProps = state => {
    const tenantApp = _.get(state.oauth, 'tenantApp', {});
    const isOpenFullScreen = _.get(state.appIntegration, 'openFullscreen', false);

    return {
      tenantApp,
      isOpenFullScreen
    };
  };

  return withI18n()(connect(mapStateToProps, mapDispatchToProps)(EmbeddedAppRoute));
}

export const ShopifyEmbeddedAppRoute = withShopifyEmbeddedAppPushState(Route);
